
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator';
import { debounce } from 'lodash-es';
import DynamicElement from '../DynamicElement';

type DynamicClassNameList = string | Record<string, any> | (string | Record<string, any>)[];

@Component({
  components: {
    DynamicElement,
  },
})
export default class HeightTransition extends Vue {
  @Prop({ type: String, default: 'div' }) readonly tag!: string;
  @Prop({ type: String, default: 'hidden' }) readonly overflow!: string;
  @Prop({ type: String, default: 'div' }) readonly contentTag!: string;
  @Prop({ type: [String, Array, Object], default: () => [] }) readonly contentClass!: DynamicClassNameList;

  @Ref() wrapperRef?: HTMLElement;
  @Ref() contentRef?: HTMLElement;

  height: string | number = 'auto';
  resizeObserver: ResizeObserver | null = null;

  get style() {
    return {
      '--overflow': this.overflow,
      '--height': !Number(this.height) ? this.height : `${this.height}px`,
    };
  }

  created() {
    this.setHeight = debounce(this.setHeight, 50);
    this.resizeObserver = new ResizeObserver(this.setHeight);
  }

  async mounted() {
    await this.$nextTick();
    if (!this.contentRef || !this.resizeObserver) return;
    this.resizeObserver.observe(this.contentRef);
    this.setHeight();
  }

  beforeDestroy() {
    this.resizeObserver?.disconnect();
  }

  public setHeight() {
    if (!this.contentRef) return;
    this.height = this.contentRef.scrollHeight || 'auto';
  }
}
